<template>
  <pui-theme-provider id="layout-admin" :theme="adminTheme" class="pui-wrapper pui-settings">
    <pui-header>
      <h1 class="header-title">{{ $t('admin.header.administration') }}</h1>
    </pui-header>
    <pui-flex class="layout-content">
      <ul class="settings-menu">
        <router-link
          :exact="true"
          :to="{ name: tab.routeName }"
          v-for="tab in authorizedTabs"
          :key="tab.id"
          tag="li"
          class="settings-menu-item"
          activeClass="active"
        >
          <a> {{ $t(tab.titleKey) }}</a>
        </router-link>
      </ul>
      <router-view class="admin-view" />
    </pui-flex>
    <pui-message-box-container>
      <pui-common-message-box
        v-for="alert in alerts"
        :key="alert.id"
        :model="alert"
        :queuedCount="queuedAlertsCount"
        @close="closeAlert"
      />
    </pui-message-box-container>
  </pui-theme-provider>
</template>
<script>
import { mapGetters } from 'vuex';

import services from '../../../core/services';
import adminTheme from '../theme';

const TABS = [
  {
    id: 'admin-platform',
    routeName: 'adminPlatform',
    titleKey: 'admin.menu.platform',
  },
  {
    id: 'admin-poster',
    routeName: 'adminPoster',
    titleKey: 'admin.menu.poster',
  },
];

export default {
  provide: {
    dialogSelector: '#layout-admin',
  },
  data() {
    return {
      adminTheme,
      authorizedTabs: [...TABS],
    };
  },
  computed: {
    ...mapGetters({
      alerts: 'alerts',
      queuedAlertsCount: 'queuedAlertsCount',
    }),
  },
  methods: {
    /**
     * Closes the alert message
     *
     * @param {Number} alertId - the id of the alert to close
     */
    closeAlert(alertId) {
      services.getService('alerts').clearAlert(alertId);
    },
  },
  created() {
    this.authorizedTabs = TABS.filter(tab => {
      const routerResolution = this.$router.resolve({ name: tab.routeName });
      if (!routerResolution) {
        return false;
      }

      const routePermission =
        routerResolution.route && routerResolution.route.meta
          ? routerResolution.route.meta.permission
          : null;

      return !routePermission || services.getService('auth').hasPermission(routePermission);
    });
  },
};
</script>
